<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    let value = JSON.parse(this.$ls.get('beers'))
    if (value && value.length > 0) {
      this.$ls.set('init', 1)
      this.$store.dispatch('LoadBeer', value).then(() => {
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style>
body, html, #app {
  height: 100%;
  min-height: 100%;
}
body {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue